import { getClassDeleteImpact } from "../../../api/elearning/classes/classes";
import { confirmDelete, DELETE_ENTITY } from "../../../utils/confirmDelete";

export async function confirmDeleteClass(classroomOrId) {
  const fallbackClassroom =
    typeof classroomOrId === "object" && classroomOrId ? classroomOrId : {};
  const classId =
    typeof classroomOrId === "object" && classroomOrId ? classroomOrId.id : classroomOrId;

  const impact = await getClassDeleteImpact(classId);
  const studentCount = Number(
    impact?.student_total_count ??
      fallbackClassroom?.student_total_count ??
      fallbackClassroom?.student_count ??
      0
  );
  const studentDeleteCount = Number(impact?.student_delete_count ?? studentCount);
  const studentKeepCount = Number(
    impact?.student_keep_count ?? Math.max(studentCount - studentDeleteCount, 0)
  );

  const extraLines = [
    `Sau khi xóa lớp này, hệ thống sẽ xóa ${studentDeleteCount} hồ sơ học viên không còn thuộc lớp nào khác.`,
  ];

  if (studentKeepCount > 0) {
    extraLines.push(
      `${studentKeepCount} học viên vẫn còn thuộc lớp khác nên sẽ được giữ lại.`
    );
  }

  return confirmDelete({
    type: DELETE_ENTITY.class,
    name: impact?.name || fallbackClassroom?.name,
    context: {
      teacherName: impact?.teacher_name || fallbackClassroom?.teacher_name,
      studentCount,
      studentDeleteCount,
      studentKeepCount,
    },
    extraLines,
    confirmText: studentDeleteCount > 0 ? "Xóa lớp và học viên" : "Xóa lớp",
    confirmDelaySeconds: 10,
  });
}
